const mainHeaderMobiles = document.querySelectorAll<HTMLElement>('.main-header-mobile');

mainHeaderMobiles.forEach(mobileHeader => {
  const button = mobileHeader.querySelector<HTMLElement>('.main-header-mobile__button');
  const panel = document.querySelector<HTMLElement>('.main-header-mobile__panel');

  button?.addEventListener('click', (e) => {
    e.preventDefault();
    panel?.classList.add('--open');
    document.body.classList.add('--disable-scroll');
  })
})
